import React from 'react'

import Header from '../../common/components/Header'
import IncidentDetailsPager from './IncidentDetailsPager'
import IncidentDetailsHeader from './IncidentDetailsHeader'
import IncidentDetails from './IncidentDetails'

import styles from './IncidentDetails.module.css'

import { useClearIncidents } from '../hooks'

const IncidentDetailsPanel = () => {
  const clear = useClearIncidents()

  return (
    <div className={styles.panel}>
      <Header>
        Incident Details
        <i
          className={'fa fa-angle-double-left ' + styles.backToList}
          onClick={clear}
        ></i>
      </Header>
      <IncidentDetailsHeader />
      <IncidentDetails />
      <IncidentDetailsPager />
    </div>
  )
}
export default IncidentDetailsPanel
